import { createContext, useContext, useState } from 'react';

export const RoomContext = createContext({});

export const roomFunctions = () => {
  const [imageProcessorCheckToken, setImageProcessorCheckToken] = useState(0);
  const [imageProcessorRefreshToken, setImageProcessorRefreshToken] = useState(0);
  const [latestAssemblyId, setLatestAssemblyId] = useState<string | null>(null);
  const [locallyEnabledAlbumIds, setLocallyEnabledAlbumIds] = useState<number[]>([]);

  const triggerImageProcessorCheck = () => setImageProcessorCheckToken((value) => value + 1);
  const triggerImageProcessorRefresh = () => setImageProcessorRefreshToken((value) => value + 1);
  const registerImageProcessorAssembly = (assemblyId: string) => setLatestAssemblyId(assemblyId);
  const enableAlbumLocally = (albumId?: number) => {
    if (!albumId) return;
    setLocallyEnabledAlbumIds((prev) => (prev.includes(albumId) ? prev : [...prev, albumId]));
  };
  const clearLocallyEnabledAlbums = () => setLocallyEnabledAlbumIds([]);

  return {
    imageProcessorCheckToken,
    triggerImageProcessorCheck,
    imageProcessorRefreshToken,
    triggerImageProcessorRefresh,
    latestAssemblyId,
    registerImageProcessorAssembly,
    locallyEnabledAlbumIds,
    enableAlbumLocally,
    clearLocallyEnabledAlbums,
  };
};

export const useRoomFunctions = () => useContext(RoomContext);
